import { Component } from 'preact';

class Helmet extends Component {
	componentDidMount() {
		document.title = this.props.title;
	}
}

export default Helmet;



// WEBPACK FOOTER //
// ./utils/helmet/index.js